import styled, { css } from 'styled-components';
import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { ViewSize } from '../../types';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;

  /* Small mobile resolutions, e.g. Galaxy Fold */
  @media screen and (max-width: 280px) {
    display: none;
  }
`;

interface IStyledButton {
  $viewSize: ViewSize;
}

export const StyledButton = styled(PrimaryButton)<IStyledButton>(
  props => css`
    ${props.$viewSize === ViewSize.SMALL &&
    css`
      width: 24px;
      align-self: stretch;
    `}
  `
);

export const StyledIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;
